export const ADMINFINANCIAL_DATA_GET="ADMINFINANCIAL_DATA_GET"
export const ADMINFINANCIAL_DATA_SUCCESS="ADMINFINANCIAL_DATA_SUCCESS"